module.exports = __webpack_public_path__ + "assets/img/body_bg-back2.220a6614.jpg";